var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3_18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.959 11.757C21.9606 10.9955 21.896 10.2353 21.766 9.48501H11.221V13.79H17.26C17.1365 14.4783 16.8748 15.1345 16.4907 15.7189C16.1065 16.3033 15.6079 16.8037 15.025 17.19V19.985H18.625C19.726 18.9235 20.5917 17.6426 21.1661 16.2252C21.7404 14.8078 22.0106 13.2855 21.959 11.757Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.22 22.68C13.944 22.7566 16.5946 21.7909 18.631 19.98L15.031 17.187C14.1635 17.7426 13.1807 18.0933 12.1574 18.2124C11.1341 18.3315 10.0971 18.2158 9.12516 17.8742C8.15322 17.5325 7.2719 16.974 6.54812 16.2408C5.82433 15.5077 5.27711 14.6192 4.94801 13.643H1.23001V16.523C2.1611 18.3742 3.58831 19.9302 5.35235 21.0174C7.11639 22.1047 9.14785 22.6803 11.22 22.68Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.94401 13.643C4.47608 12.2547 4.47608 10.7513 4.94401 9.36301V6.48301H1.23001C0.447949 8.04085 0.0406799 9.75988 0.0406799 11.503C0.0406799 13.2461 0.447949 14.9652 1.23001 16.523L4.94401 13.643Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.22 4.74501C12.8142 4.71919 14.3547 5.32115 15.509 6.42101L18.701 3.22901C16.6767 1.32937 13.9958 0.286894 11.22 0.320007C9.14723 0.319775 7.11522 0.895938 5.35105 1.98411C3.58687 3.07228 2.16005 4.62959 1.23001 6.48201L4.94401 9.36201C5.3765 8.03314 6.21445 6.87316 7.34013 6.04505C8.46581 5.21693 9.82265 4.76229 11.22 4.74501Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.918,
    height: 22.36,
    fill: "white",
    transform: "translate(0.0410156 0.320007)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.1454921bca9b17a6c1e514db930d64ff.svg";
export { ForwardRef as ReactComponent };